import { HistoryType } from '@shared/utils/History/HistoryType';
import { InstrumentTypes } from '@shared/utils/Instruments/InstrumentTypes';
import { OptionPutCall } from '@shared/utils/Instruments/OptionPutCall';
import { DataCache } from '../DataCache';
export class PositionExerciseOptionValidator {
    constructor(position) {
        this.position = position;
        this.instrument = position.Instrument;
        this.account = position.Account;
        this.underlier = this.instrument.ForwardBaseInstrument;
        this.subscribeUnderlier();
    }
    isAllowExercise() {
        if (!this.instrument.AllowExerciseForItmOption)
            return true; // always enabled
        const underlierPrice = this.underlier.Level1.GetLastPrice(this.account);
        if (isNaN(underlierPrice))
            return false;
        const strikePrice = this.instrument.StrikePrice;
        if (this.instrument.PutCall === OptionPutCall.OPTION_CALL_VANILLA) {
            return underlierPrice > strikePrice;
        }
        else if (this.instrument.PutCall === OptionPutCall.OPTION_PUT_VANILLA) {
            return underlierPrice < strikePrice;
        }
        return false;
    }
    newQuote(msg) { }
    dispose() {
        this.unsubscribeUnderlier();
    }
    subscribeUnderlier() {
        if (!this.isAllowExerciseOnlyForItmOptions())
            return;
        DataCache.FQuoteCache.addListener(this.underlier, this, HistoryType.QUOTE_LEVEL1);
        DataCache.FQuoteCache.addListener(this.underlier, this, HistoryType.QUOTE_TRADES);
    }
    unsubscribeUnderlier() {
        if (!this.isAllowExerciseOnlyForItmOptions())
            return;
        DataCache.FQuoteCache.removeListener(this.underlier, this, HistoryType.QUOTE_LEVEL1);
        DataCache.FQuoteCache.removeListener(this.underlier, this, HistoryType.QUOTE_TRADES);
    }
    isAllowExerciseOnlyForItmOptions() {
        return (this.instrument.InstrType === InstrumentTypes.OPTIONS &&
            !isNullOrUndefined(this.underlier) &&
            this.instrument.AllowExerciseForItmOption);
    }
}
